/**
 * Events summary card — lists the first 5 events with spending progress bars.
 */
import React from 'react';
import { Card } from '../ui/card';
import { Progress } from '../ui/progress';
import { ArrowRight } from 'iconoir-react';
import { formatCurrency } from './constants';

export default function EventsSummaryCard({ events, currency }) {
  return (
    <Card className="card-surface p-6" data-testid="events-summary-card">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-serif text-xl text-charcoal">Events</h2>
        <a href="/events" className="text-terracotta hover:text-terracotta-dark text-xs flex items-center gap-1">
          <ArrowRight className="w-3 h-3" />
        </a>
      </div>
      {events?.length > 0 ? (
        <div className="space-y-3">
          {events.slice(0, 5).map((event) => {
            const progress = event.budget ? (event.spent / event.budget) * 100 : 0;
            return (
              <div key={event.id}>
                <div className="flex items-center justify-between text-xs mb-1">
                  <span className="text-charcoal">{event.name}</span>
                  <span className="font-mono text-muted">{formatCurrency(event.spent, currency)}</span>
                </div>
                <Progress value={Math.min(progress, 100)} className="h-1" />
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-muted text-center py-4 text-sm">No events yet</p>
      )}
    </Card>
  );
}
